export let jsplumbConfig = {
    ins:{
		Connector: [
			"Flowchart",
			{
				gap: 2,
				cornerRadius: 8,
				alwaysRespectStubs: true
			}
		],
        ConnectionsDetachable:true,
		ConnectionOverlays: [
			[
				'Arrow',
				{
					width: 10, 
					length: 10, 
					location: 1
				}
			]
		],
        MaxConnections: -1,
		PaintStyle: {
			stroke: "#1890ff",
			strokeWidth: 2
		},
		HoverPaintStyle: {
			stroke: "red",
			strokeWidth: 3
		},
		EndpointStyle: {
			fill: "#d6efff",
			stroke: "#1890ff",
			strokeWidth: 1,
			radius: 4
		},
		EndpointHoverStyle: {
			stroke: "red",
			fill: "red"
		}
    },
    selectConnection:{
        outlineWidth:3,
        outlineStroke:"#ffce8f"
    },
    linkDefaultPropData:{
        linkType:"Flowchart",
        BezierCurviness:150,
        StraightStub:0,
        StraightGap:0,
        FlowchartStub:30,
        FlowchartGap:2,
        FlowchartCornerRadius:8,
        FlowchartMidpoint:0.5,
        StateMachineCurviness:10,
        StateMachineMargin:5,
        StateMachineProximityLimit:80,
        overlayList:[
            {
                overlayId:"arrow",
                type:"Arrow",
                location:"1",
                arrowSize:"10,10",
                direction:1
            }
        ]
    }
}